import {
  List,
  Datagrid,
  TextField,
  EditButton,
  DeleteButton,
  ReferenceField,
  NumberField,
} from 'react-admin';

export const AttributeList = () => (
  <List>
    <Datagrid>
      <TextField source="name" />
      <TextField source="slug" />
      <ReferenceField source="groupId" reference="attribute-groups" link="show">
        <TextField source="name" />
      </ReferenceField>
      <NumberField source="sortOrder" />
      <EditButton />
      <DeleteButton mutationMode="pessimistic" />
    </Datagrid>
  </List>
);
